/* eslint-disable */
jQuery(document).ready(function($) {
  $('.generate-pdf-button').on('click', function(e) {
    console.log('Button clicked'); // Add this line

    e.preventDefault();

    var postID = $(this).data('post-id');
      
    // Send AJAX request to the backend
    $.ajax({
        url: ajaxurl, // WordPress AJAX endpoint
        type: 'POST',
        dataType: 'json',
        data: {
            action: 'generate_pdf',
            post_id: postID
        },
        success: function(response) {
            // Handle the response and prompt the user to download the PDF
            if (response.success) {
              var downloadLink = document.createElement('a');
              downloadLink.href = 'data:application/pdf;base64,' + response.data.content;
              downloadLink.target = '_blank';
              downloadLink.download = response.data.filename;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            } else {
              alert('PDF generation failed for Post ID: ' + response.data.post_id + '. Please try again.');
            }
        },
        error: function() {
            alert('An error occurred while generating the PDF.');
        }
    });
  });
});
